import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { translate } from 'secullum-i18n';
import {
  Details,
  Space,
  formatDate,
  getTestID,
  isTablet
} from 'secullum-react-native-ui';
import { getTheme } from '../../modules/layout';
import { MovimentacaoFeriasDados } from '../../modules/types';

interface Props {
  movimentacoes: Array<MovimentacaoFeriasDados>;
}

class ListaLancamentosFerias extends React.Component<Props> {
  formatarLancamento = (movimentacao: MovimentacaoFeriasDados) => {
    const formatoData = 'dd/MM/yy';

    let periodo = formatDate(movimentacao.data, formatoData);

    if (movimentacao.dataFim) {
      periodo += ` ${translate('Até').toLowerCase()} ${formatDate(
        movimentacao.dataFim,
        formatoData
      )}`;
    }

    return `${movimentacao.descricaoMovimentacao} - ${periodo} - ${
      movimentacao.dias
    } ${translate('dias')}`;
  };

  montarLinhas = () => {
    return this.props.movimentacoes.map((movimentacao, index) => ({
      render: () => (
        <View style={styles.lineContainer}>
          <Text
            nativeID={`ferias-lancamento-${index}`}
            testID={getTestID(`ferias-lancamento-${index}`)}
            style={styles.lineText}
          >
            {this.formatarLancamento(movimentacao)}
          </Text>
        </View>
      )
    }));
  };

  render() {
    if (this.props.movimentacoes.length === 0) {
      return null;
    }

    return (
      <>
        <Space />
        <Details
          titleNativeId="ferias-lancamentos-titulo"
          title={translate('Lançamentos Realizados')}
          lines={this.montarLinhas()}
        />
      </>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  lineContainer: {
    padding: 10,
    justifyContent: 'center',
    minHeight: 45
  },
  lineText: {
    fontFamily: theme.fontFamily2,
    fontSize: isTablet() ? 18 : 14,
    color: theme.textColor1
  }
});

export default ListaLancamentosFerias;
